import React from 'react'
import { IonChip, IonLabel } from '@ionic/react'

const ChipComponent: React.FC<{ label: string; className?: string }> = ({ label, className }) => (
  <IonChip outline className={`${className} body-survey-chip body-survey-left-right-chip-size`}>
    <IonLabel className='body-survey-chip-label'>{label}</IonLabel>
  </IonChip>
)

export default ChipComponent
